import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import CustomerForm from './ClientiForm';
import { storeActions } from '../../store/configureStore';
import OptionModal from '../common/OptionModal';

export class EditClientePage extends React.Component {
  state = {
    isOpen: false,
    modalContent: 'remove_confirm',
    btnEnabled: true,
  };

  handleOpenModal = () => {
    this.setState(() => ({
      isOpen: true,
    }));
  };

  handleCloseModal = () => {
    this.setState({ isOpen: false });
  };

  onSubmit = async (cliente) => {
    await this.props.startEditCustomer(this.props.cliente.id, cliente);
    this.props.history.push(`/clientiview/${this.props.cliente.id}`);
  };

  // prima di cancellare verifico se non è usato in altri campi
  onValidate = () => {
    const lead = this.props.leads.find(
      (lead) => lead.leadId === this.props.cliente.id
    );
    const deals = this.props.deals.find(
      (deal) =>
        deal.agenziaPartnerId === this.props.cliente.id ||
        deal.venditoreId === this.props.cliente.id ||
        deal.venditoreId2 === this.props.cliente.id ||
        deal.acquirenteId === this.props.cliente.id ||
        deal.acquirenteId2 === this.props.cliente.id ||
        deal.notaioId === this.props.cliente.id
    );
    const oggetti = this.props.oggetti.find(
      (oggetto) =>
        oggetto.proprietarioId === this.props.cliente.id ||
        oggetto.proprietarioId2 === this.props.cliente.id ||
        oggetto.verwalter === this.props.cliente.id
    );
    const fatture = this.props.fatture.find(
      (fattura) =>
        fattura.clienteId === this.props.cliente.id ||
        fattura.clienteId2 === this.props.cliente.id
    );
    if (!lead && !deals && !oggetti && !fatture) {
      return true;
    } else {
      return false;
    }
  };

  onRemove = () => {
    if (this.onValidate()) {
      this.props.startRemoveCustomer({ id: this.props.cliente.id });
      this.props.history.push('/clienti');
    } else {
      this.setState(() => ({
        isOpen: true,
        modalContent: 'cannot_delete',
        btnEnabled: false,
      }));
    }
  };

  onDisable = () => {
    if (this.onValidate()) {
      this.props.startEditCustomer(this.props.cliente.id, {
        ...this.props.cliente,
        visible: false,
      });
      this.props.history.push('/clienti');
    } else {
      this.setState(() => ({
        isOpen: true,
        modalContent: 'cannot_delete',
        btnEnabled: false,
      }));
    }
  };

  render() {
    if (
      !this.props.cliente ||
      (this.props.utente.role === 'Mitarbeiter' && !this.props.cliente.visible)
    ) {
      this.props.history.push('/clienti');
      return <div>Loading...</div>;
    }
    return (
      <div>
        <div>
          <div className='container'>
            <h1>{this.props.t('Modifica contatto')}</h1>
          </div>
        </div>
        <div className='container'>
          <OptionModal
            isOpen={this.state.isOpen}
            contentLabel={'remove'}
            modalContent={this.props.t(this.state.modalContent)}
            onCancel={this.handleCloseModal}
            onConfirm={
              this.props.utente.role === 'Admin'
                ? this.onRemove
                : this.onDisable
            }
            btnEnabled={this.state.btnEnabled}
          />
          <CustomerForm
            customer={this.props.cliente}
            onSubmit={this.onSubmit}
          />
          <button
            className='btn-floating red margine-basso'
            onClick={this.handleOpenModal}
          >
            <i className='material-icons'>delete</i>
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  cliente: state.clienti.find(
    (cliente) => cliente.id === props.match.params.id
  ),
  utente: state.utenti.find(
    (utente) => utente.firebaseAuthId === state.auth.uid
  ),
  leads: state.leads,
  deals: state.deals,
  oggetti: state.oggetti,
  fatture: state.fatture,
});

const mapDispatchToProps = (dispatch) => ({
  startEditCustomer: (id, cliente, visible) =>
    dispatch(
      storeActions
        .find((action) => action.label === 'clienti')
        .startEditAction(id, cliente, visible)
    ),
  startRemoveCustomer: (data) =>
    dispatch(
      storeActions
        .find((action) => action.label === 'clienti')
        .startRemoveAction(data)
    ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(EditClientePage));



// WEBPACK FOOTER //
// ./src/components/clienti/EditClientiPage.js